import { createEmptyDiagramDocument } from '../diagram.js'
import type { DiagramDocument } from '../diagram.js'
import { Obj } from '../entity.js'
import { ObjOptions } from './base.js'

export interface DiagramObjOptions extends Omit<ObjOptions, 'childOf' | 'data'> {
  childOf: string
  data?: DiagramDocument
}

export class DiagramObj extends Obj<'Diagram'> {
  readonly typeOf = 'Diagram' as const

  public constructor(opts: DiagramObjOptions) {
    if (!opts.childOf) {
      throw new Error('Diagram objects require a non-empty childOf')
    }

    super({
      ...opts,
      typeOf: 'Diagram',
      data: opts.data ?? createEmptyDiagramDocument()
    })
  }
}

export function isDiagramObj(obj: any): obj is DiagramObj {
  return obj.typeOf === 'Diagram'
}
